module.exports = __webpack_public_path__ + "img/169.29ce860f.jpg";